import React from 'react';
import { PieChart, Pie, Cell } from 'recharts';

const dataPie = [
  { name: 'data1', value: 30, color: '#ff000' },
  { name: 'data2', value: 40, color: '#7EA5DD' },
  { name: 'data3', value: 90, color: '#457FCF' },
];

const dataDonut = [
  { name: 'data1', value: 30, color: '#8ECF4D' },
  { name: 'data2', value: 40, color: '#5DBA00' },
];

const PieToShow = ({ type }) => {
  const data = type === 'pie' ? dataPie : dataDonut;
  const innerRadius = type === 'donut' ? 60 : 0;

  return (
    <PieChart width={218} height={218}>
      <Pie
        data={data}
        dataKey="value"
        nameKey="name"
        cx="50%"
        cy="50%"
        outerRadius={100}
        innerRadius={innerRadius}
      >
        {data.map((entry, i) => (
          <Cell key={i} fill={entry.color} />
        ))}
      </Pie>
    </PieChart>
  );
};

export default PieToShow;
